<div class="hp-pw-wrapper">
  <!-- Masked bullet overlay when hidden -->
  <span
    *ngIf="!inputState.isShow"
    class="hp-pw-mirror"
    aria-hidden="true"
  >{{ maskBulletText }}</span>

  <!-- Actual input (always type=text, transparent text when masked) -->
  <input
    #innerPassword
    [attr.id]="name"
    [name]="name"
    [placeholder]="placeholder"
    type="text"
    autocomplete="current-password"
    autocapitalize="off"
    spellcheck="false"
    (blur)="blur(); touched()"
    (focus)="focus()"
    (input)="onInnerInput($event)"
    [class.hp-pw-entry--masked]="!inputState.isShow"
    [class.hp-pw-entry--plain]="inputState.isShow"
    class="hp-pw-entry"
  />


</div>
